import { Outlet } from 'react-router';

import { useSelectedClientStore } from '@entities/shared/client';

import { Snackbar } from '@shared/ui';

export const RootLayout = () => {
  const selectedClient = useSelectedClientStore();

  return (
    <>
      {/* Remount the route subtree on client switch so stale observers (e.g. per-contract
          balance queries) detach before anything refetches under the new X-Client-Id */}
      <Outlet key={selectedClient.clientId} />
      <Snackbar />
    </>
  );
};
